import store from "../../app/store";
import scope from "../../app/rootScope";
import utils from "../../app/utils";
import products from "../../app/products";
import render from "../../app/render";
import satTileLoader from "./SatTileLoader";
import loader from "../../app/dataLoader";
import test from "../../app/performanceTest";
import http from "../../app/http";
import lrucache from "../../app/lruCache";
import SatTileLoader from "./SatTileLoader";
import broadcast from "../../app/broadcast";

const productSat=products.satellite;

export default L.TileLayer.extend({

    latestParams: {},
    inMotion: 0,
    syncCounter: 0,
    // cache: new lrucache(75),


    onAdd: function(map) {

        render.emit("updateBasemap", {coverWholeMap: true, hasSea: false});

        L.GridLayer.prototype.onAdd.call(this, map);
        map.on("movestart", this.onMoveStart, this);
        map.on("moveend", this.onMoveEnd, this);
        this.on("load", this.checkLoaded, this);
    },
    onMoveStart: function() {
        this.inMotion = 1;
        // console.info("moviendo");
        this.syncCounter++;
        broadcast.emit("SatLayerMoveStart");
    },
    onMoveEnd: function() {
        this.inMotion = 0;
        this._loading || this.redrawFinished();

        // console.info("terminando de mover");
        broadcast.emit("SatLayerMoveStop");
    },
    checkLoaded: function() {
        this.inMotion || this.redrawFinished()
    },
    redrawFinished: function() {
        render.emit("rendered", "tileLayer")
    },




    createTile: function(coords, done) {

        var subdomain = this._getSubdomain(coords);
        var url = utils.template(this.latestParams.fullPath.replace("<z>", coords.z).replace("<y>", coords.y).replace("<x>", coords.x), {s: subdomain});
        var urlNext = utils.template(this.latestParams.fullNextPath.replace("<z>", coords.z).replace("<y>", coords.y).replace("<x>", coords.x), {s: subdomain});
        var cache = this.cache;
        var canvas = document.createElement("canvas");
        canvas.width = canvas.height = scope.isRetina ? 512 : 256;
        SatTileLoader.loadTile(url, urlNext).then(function (loader){
            var ctx = canvas.getContext("2d");
            ctx.drawImage(loader.tile, 0, 0, loader.tile.width, loader.tile.height);

            done(void 0, canvas);

        });

        return canvas;
    },

    overlayChanged: function(nameoverlay) {
        const timestamp = store.get("satelliteTimestamp");
        const satelliteCalendar = store.get("satelliteCalendar");
        if (satelliteCalendar) {
            const params = {

                server: this.server || productSat.server || scope.server,
                directory: productSat.directory,
                filename: nameoverlay,
                fileSuffix: productSat.fileSuffix,
                path: satelliteCalendar.ts2path(timestamp),
                nextpath: satelliteCalendar.ts2nextpath(timestamp),
                maxTileZoom: productSat.maxTileZoom,
                res: scope.isRetina ? "@2x" : ""
            };

            this.latestParams.fullPath = utils.template(productSat.pathGenerator, params); //+ (scope.isRetina ? "&res=2" : "&res=1");
            const nextPathGenerator = productSat.pathGenerator.replace(/\{\{?\s*(path)\s*\}?\}/g, "{nextpath}");
            this.latestParams.fullNextPath = utils.template(nextPathGenerator, params); // + (scope.isRetina ? "&res=2" : "&res=1");

            this.redrawLayer();
        }

    },

    timestampChanged: function(timestamp) {
        const overlay = store.get("overlay");
        const satelliteCalendar = store.get("satelliteCalendar");
        const params =  {

            server: this.server || productSat.server || scope.server,
            directory: productSat.directory,
            filename: overlay,
            fileSuffix:  productSat.fileSuffix,
            path: satelliteCalendar.ts2path(timestamp),
            nextpath: satelliteCalendar.ts2nextpath(timestamp),
            maxTileZoom: productSat.maxTileZoom,
            res: scope.isRetina ? "@2x" : ""
        };


        this.latestParams.fullPath = utils.template(productSat.pathGenerator, params); //+ (scope.isRetina ? "&res=2" : "&res=1");
        const nextPathGenerator = productSat.pathGenerator.replace(/\{\{?\s*(path)\s*\}?\}/g, "{nextpath}");
        this.latestParams.fullNextPath = utils.template(nextPathGenerator, params); // + (scope.isRetina ? "&res=2" : "&res=1");

        this.redrawLayer();

    },

    redrawLayer: function() {
        var map = this._map
            , bounds = map.getPixelBounds()
            , TLPoint = bounds.min
            , BRPoint = bounds.max
            , TLcoords = TLPoint.divideBy(256)._floor()
            , BRcoords = BRPoint.divideBy(256)._floor()
            , boundTiles = L.bounds(TLcoords, BRcoords)
            , zoom = Math.round(map.getZoom());

        // console.info("redrawlayer");

        if (zoom > 11)
            this.redrawFinished();
        else {
            this.removeOtherTiles(zoom, boundTiles);
            var coords = this.sortTilesFromCenterOut(boundTiles);
            this._tilesToLoad = coords.length;
            for (var i = 0; i < coords.length; i++) {
                var coordTile = coords[i]
                    , key = this._tileCoordsToKey(coordTile);
                if(key in this._tiles)
                    this.redrawTile(this._tiles[key])
                else
                    --this._tilesToLoad || this.redrawFinished()   // Si llega a 0 llama a redrawFinished
            }
        }
    },
    // Repinta la tesela
    redrawTile: function(tile) {
        var layercanvas = this;
        tile.coords = this._wrapCoords(tile.coords);

        var subdomain = this._getSubdomain(tile.coords);
        var url = utils.template(this.latestParams.fullPath.replace("<z>", tile.coords.z).replace("<y>", tile.coords.y).replace("<x>", tile.coords.x), {s: subdomain});
        var urlNext = utils.template(this.latestParams.fullNextPath.replace("<z>", tile.coords.z).replace("<y>", tile.coords.y).replace("<x>", tile.coords.x), {s: subdomain});


        SatTileLoader.loadTile(url, urlNext).then(function (loader){
            var ctx = tile.el.getContext("2d");
            ctx.drawImage(loader.tile, 0, 0, loader.tile.width, loader.tile.height);

            if ( --layercanvas._tilesToLoad === 0) {
                layercanvas.redrawFinished();
            }

        });

    },


    // Ordena las teselas de menor a mayor distancia al centro
    sortTilesFromCenterOut: function(boundTiles) {
        var y, x, coordsTiles = [], center = boundTiles.getCenter(), zoom = this._tileZoom;
        for (y = boundTiles.min.y; y <= boundTiles.max.y; y++)
            for (x = boundTiles.min.x; x <= boundTiles.max.x; x++) {
                var coord = new L.Point(x,y);
                coord.z = zoom;
                coordsTiles.push(coord);
            }
        coordsTiles.sort(function(elem1, elem2) {
            return elem1.distanceTo(center) - elem2.distanceTo(center)
        });
        return  coordsTiles;
    },
    // Borra las teselas que se salen de los límites
    removeOtherTiles: function(zoom, boundTiles) {
        var min = boundTiles.min
            , max = boundTiles.max;
        for (var tilekey in this._tiles) {
            var a = tilekey.split(":")
                , x = a[0]
                , y = a[1];
            (+a[2] !== zoom || +x < min.x || +x > max.x || +y < min.y || +y > max.y) && this._removeTile(tilekey)
        }
    },


    preload: function (timestamp, step){
        let map = this._map
            , bounds = map.getPixelBounds()
            , TLPoint = bounds.min
            , BRPoint = bounds.max
            , TLcoords = TLPoint.divideBy(256)._floor()
            , BRcoords = BRPoint.divideBy(256)._floor()
            , boundTiles = L.bounds(TLcoords, BRcoords)
            , zoom = Math.round(map.getZoom())
            , ntiles = (boundTiles.max.x - boundTiles.min.x + 1) * (boundTiles.max.y - boundTiles.min.y + 1)
            ;

        const overlay = store.get("overlay");
        const satCalendar = store.get("satelliteCalendar");
        // let ts = store.get("satelliteTimestamp");

        if (typeof step === "undefined")
            step = 300 * 1000;
        // Cuando el step es mayor que 300 es necesario que la caché sea más grande
        const mul = step / 300 * 1000;

        const nframes = (satCalendar.end - timestamp) / step + 1;
        let tilestoload = ntiles * nframes;
        const syncCounter = this.syncCounter;

        // console.info("nframes: "+ nframes)
        // console.info("ntiles: "+ ntiles)
        // satTileLoader.
        satTileLoader.resizeCache(tilestoload * mul);


        const params =  {

            server: this.server || productSat.server || scope.server,
            directory: productSat.directory,
            filename: overlay,
            fileSuffix:  productSat.fileSuffix,
            path: satCalendar.ts2path(timestamp),
            // nextpath: satCalendar.ts2nextpath(ts),
            maxTileZoom: productSat.maxTileZoom,
            res: scope.isRetina ? "@2x" : ""

        };


        const satLayer = this;

        var y, x, nf, url;
        for (nf = 0; nf < nframes; nf++) {
            // console.info(new Date(timestamp));
            params.path = satCalendar.ts2path(timestamp);
            const fullPath = utils.template(productSat.pathGenerator, params);
            // console.info ("fullPath: "+ fullPath);

            for (y = boundTiles.min.y; y <= boundTiles.max.y; y++)
                for (x = boundTiles.min.x; x <= boundTiles.max.x; x++) {

                    url = utils.template(fullPath.replace("<z>", zoom.toString()).replace("<y>", y).replace("<x>", x), {s: this._getSubdomain({x: x, y: y})});
                    // console.info(url);
                    satTileLoader.loadTile(url).then(
                        function (loader) {
                            if (satLayer.syncCounter === syncCounter) {
                                if (--tilestoload === 0) {
                                    // console.info("Se cargaron todas las teselas")
                                    broadcast.emit("preloadedtiles", "complete")
                                } else {
                                    broadcast.emit("preloadedtiles", Math.round((1 - tilestoload / (ntiles * nframes)) * 100))
                                }
                            }
                        }
                    );
                }
            timestamp = satCalendar.bestTs(timestamp + step);

        }

        // console.info ("ntiles per frame: "+ (boundTiles.max.x - boundTiles.min.x) * (boundTiles.max.y - boundTiles.min.y) );

    },

    init: function (){
        // console.info(params);
        const overlay = store.get("overlay");
        const satCalendar = store.get("satelliteCalendar");
        const ts = store.get("satelliteTimestamp");

        const nextPathGenerator = productSat.pathGenerator.replace(/\{\{?\s*(path)\s*\}?\}/g, "{nextpath}");

        const params =  {

            server: this.server || productSat.server || scope.server,
            directory: productSat.directory,
            filename: overlay,
            fileSuffix:  productSat.fileSuffix,
            path: satCalendar.ts2path(ts),
            nextpath: satCalendar.ts2nextpath(ts),
            maxTileZoom: productSat.maxTileZoom,
            res: scope.isRetina ? "@2x" : ""

        };
        //+ scope.isRetina ? "&res=2" : "&res=1"
        this.latestParams = {
            fullPath : utils.template(productSat.pathGenerator, params),// + (scope.isRetina ? "&res=2" : "&res=1"),
            fullNextPath : utils.template(nextPathGenerator, params), // + (scope.isRetina ? "&res=2" : "&res=1"),
            maxTileZoom : productSat.maxTileZoom,
            layer: overlay,
            fileSuffix: "jpg"
        }

    }
});
